export const orderStatusesEnum = Object.freeze({
  NEW: 'NEW',
  FILLED: 'FILLED',
  CANCELED: 'CANCELED',
  PENDING_CANCEL: 'PENDING_CANCEL',
  PENDING_REPLACE: 'PENDING_REPLACE',
  WORKING: 'WORKING',
  REJECTED: 'REJECTED',
  REPLACED: 'REPLACED',
  MARKET: 'MARKET',
  PENDING: 'PENDING',
  PENDING_NEW: 'PENDING_NEW',
  REJECTED_SYS: 'REJECTED_SYS',
})

export const orderTypesEnum = Object.freeze({
  MARKET: 'MARKET',
  LIMIT: 'LIMIT',
  STOP: 'STOP',
  STOP_LIMIT: 'STOP_LIMIT',
})

export const orderLegTypeEnum = Object.freeze({
  EQUITY: 'EQUITY',
})

export const orderLegSideEnum = Object.freeze({
  BUY: 'BUY',
  SELL: 'SELL',
})

export const orderDurationEnum = Object.freeze({
  DAY: 'DAY',
  GOOD_TILL_CANCEL: 'GOOD_TILL_CANCEL',
  GOOD_TILL_DATE: 'GOOD_TILL_DATE',
})

export const executionReportExecTypeEnum = Object.freeze({
  FILL: 'FILL',
  PARTIAL_FILL: 'PARTIAL_FILL',
})

export const orderOpenCloseEnum = Object.freeze({
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
})
